// color
export const RED = '#ff603f';
export const BLUE = '#2879ff';
export const GREEN = '#00c853';
export const WHITE = '#fff';
export const GRAY = '#c9c9c9';
export const GRAY_DARK = '#969799';
// border
export const BORDER = 'rv-hairline';
export const BORDER_TOP = `${BORDER}--top`;
export const BORDER_LEFT = `${BORDER}--left`;
export const BORDER_RIGHT = `${BORDER}--right`;
export const BORDER_BOTTOM = `${BORDER}--bottom`;
export const BORDER_SURROUND = `${BORDER}--surround`;
export const BORDER_TOP_BOTTOM = `${BORDER}--top-bottom`;
export const BORDER_UNSET_TOP_BOTTOM = `${BORDER}-unset--top-bottom`;
// shadow
export const SHADOW = 'rv-shadow';
// component type key
export const COMPONENT_TYPE_KEY = '__REACT_VANT_COMPONENT';